var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCanSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1780_6028)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#E4E7EB"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1780_6028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 4C10.4178 4 8.87103 4.46919 7.55544 5.34824C6.23985 6.22729 5.21447 7.47672 4.60897 8.93853C4.00347 10.4003 3.84504 12.0089 4.15372 13.5607C4.4624 15.1126 5.22433 16.538 6.34315 17.6569C7.46197 18.7757 8.88743 19.5376 10.4393 19.8463C11.9911 20.155 13.5997 19.9965 15.0615 19.391C16.5233 18.7855 17.7727 17.7602 18.6518 16.4446C19.5308 15.129 20 13.5823 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4ZM17.225 9.315L10.655 15.88L6.775 12C6.6424 11.8674 6.5679 11.6875 6.5679 11.5C6.5679 11.3125 6.6424 11.1326 6.775 11C6.90761 10.8674 7.08747 10.7929 7.275 10.7929C7.46254 10.7929 7.6424 10.8674 7.775 11L10.665 13.89L16.235 8.325C16.3007 8.25934 16.3786 8.20725 16.4644 8.17172C16.5502 8.13618 16.6421 8.11789 16.735 8.11789C16.8279 8.11789 16.9198 8.13618 17.0056 8.17172C17.0914 8.20725 17.1693 8.25934 17.235 8.325C17.3007 8.39066 17.3527 8.46861 17.3883 8.5544C17.4238 8.64019 17.4421 8.73214 17.4421 8.825C17.4421 8.91786 17.4238 9.00981 17.3883 9.0956C17.3527 9.18139 17.3007 9.25934 17.235 9.325L17.225 9.315Z",
    fill: "#35A936"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1780_6028"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1780_6028"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanSuccess);
export default __webpack_public_path__ + "static/media/canSuccess.76568de62b24bf6a699711a2fc536a6b.svg";
export { ForwardRef as ReactComponent };